import { withProfiler } from "@sentry/react";
import type { FC } from "react";

import type { Flipper } from "@shared/types/flipper";
import { ErrorBoundary, Providers } from "@unauthenticated/signupSignin/components";
import type { PatientAttributes } from "@unauthenticated/signupSignin/data/types";
import { PatientStoreActivationPage } from "@unauthenticated/signupSignin/scenes";

interface Props {
  patientAttributes: PatientAttributes;
  emailRegex: string;
  treatmentPlanTerm: string;
  additionalAttributes?: any;
  currentCountry: string;
  csuid: string;
  flippers: Flipper[];
  newSSOErrors?: string;
  roleId: string;
  storeId: string;
  e2e: boolean;
  analyticsAnonymousId: string;
}

const PatientInvitationPage: FC<Props> = ({
  patientAttributes,
  emailRegex,
  treatmentPlanTerm,
  additionalAttributes,
  currentCountry,
  csuid,
  flippers,
  newSSOErrors,
  roleId,
  storeId,
  e2e,
  analyticsAnonymousId,
}) => {
  const pageVersion = "react_with_sso";

  return (
    <Providers
      emailRegex={emailRegex}
      treatmentPlanTerm={treatmentPlanTerm}
      currentCountry={currentCountry}
      flippers={flippers}
      e2e={e2e}
      analyticsAnonymousId={analyticsAnonymousId}
    >
      <ErrorBoundary {...{ csuid, flippers, pageVersion, roleId, storeId }}>
        <PatientStoreActivationPage
          patientAttributes={patientAttributes}
          additionalAttributes={additionalAttributes}
          csuid={`${csuid}`}
          pageVersion={pageVersion}
          newSSOErrors={newSSOErrors}
        />
      </ErrorBoundary>
    </Providers>
  );
};

const PatientInvitationPageWithProfiler = withProfiler(PatientInvitationPage);
export { PatientInvitationPageWithProfiler as PatientInvitationPage };
